import React from "react";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "../components/ui/accordion";

const FAQS = [
    {
        q: "Is the packaging really discreet?",
        a: "Yes. Every Veloura order ships in an unbranded matte mailer with no logo, no product name, and no suggestive copy. The return address reads 'V. Atelier' — a neutral name we use specifically to protect your privacy. Your invoice never mentions product names.",
    },
    {
        q: "What does the shipping label look like?",
        a: "The shipping label shows only 'V. Atelier' as the sender, your name and address, and a tracking number. There is nothing on the exterior that indicates the contents.",
    },
    {
        q: "Do you offer Cash on Delivery?",
        a: "Yes — COD is available across India for orders up to ₹15,000. At the door, the courier will ask for the exact amount due. The package remains unbranded at every stage.",
    },
    {
        q: "How long does shipping take?",
        a: "Metros: 2–4 business days. Rest of India: 4–7 business days. You'll receive an SMS with your tracking link (the link does not reveal product names either).",
    },
    {
        q: "Can I return or exchange a product?",
        a: "Unopened, unused pieces can be returned within 14 days in their original discreet packaging for a full refund. For hygiene reasons, opened intimate products cannot be returned, but we'll always help troubleshoot — please contact our concierge.",
    },
    {
        q: "Are your formulations safe?",
        a: "Every serum, oil, and lubricant is dermatologist-reviewed and free of glycerin, parabens, fragrance, propylene glycol, and nonoxynol-9. Our silicone is medical-grade and body-safe.",
    },
    {
        q: "How do I charge my massager?",
        a: "All Veloura massagers use USB-C magnetic charging. A cable is included in every box. A full charge takes 60–90 minutes and typically lasts 2–4 hours of use.",
    },
    {
        q: "How do I reach a real person?",
        a: "Our concierge answers on WhatsApp at +91-9999-999-999, weekdays 10am–8pm IST. You can also use the floating Concierge button on any page.",
    },
    {
        q: "Do you ship internationally?",
        a: "We currently ship within India. Select international markets are coming in 2026 — join our journal to be notified.",
    },
];

export default function FAQ() {
    return (
        <div
            className="max-w-[900px] mx-auto px-6 md:px-12 pt-16 pb-32"
            data-testid="faq-page"
        >
            <div className="overline mb-4">Frequently asked</div>
            <h1
                className="font-serif text-5xl sm:text-6xl tracking-tight mb-6"
                style={{ color: "var(--vl-text)" }}
            >
                Questions,{" "}
                <em
                    style={{
                        color: "var(--vl-rose)",
                        fontStyle: "italic",
                    }}
                >
                    answered quietly.
                </em>
            </h1>
            <p
                className="max-w-2xl mb-14"
                style={{
                    color: "var(--vl-muted)",
                    lineHeight: 1.8,
                }}
            >
                Everything about shipping, privacy, returns, and materials —
                in one place. Can't find an answer? Message our concierge on
                WhatsApp.
            </p>

            <Accordion type="single" collapsible className="w-full">
                {FAQS.map((f, i) => (
                    <AccordionItem
                        key={f.q}
                        value={`item-${i}`}
                        data-testid={`faq-item-${i}`}
                        style={{
                            borderBottom: "1px solid var(--vl-border)",
                        }}
                    >
                        <AccordionTrigger
                            className="text-left font-serif text-xl sm:text-2xl py-6 hover:no-underline"
                            style={{ color: "var(--vl-text)" }}
                        >
                            {f.q}
                        </AccordionTrigger>
                        <AccordionContent
                            className="text-base pb-6"
                            style={{
                                color: "var(--vl-muted)",
                                lineHeight: 1.9,
                            }}
                        >
                            {f.a}
                        </AccordionContent>
                    </AccordionItem>
                ))}
            </Accordion>
        </div>
    );
}
